import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

import AaCatInfo from './AaCatInfo.js';

/**
 * Dialog content can be scrollable.
 */
export default class GradingCat extends React.Component {
  state = {
    open: false,
  };

  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };

  render() {
    const actions = [
      <FlatButton
        label="OK"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleClose}
      />
    ];

    const dialogArray = [

    ]

    return (

      <div>


        <div style = {{paddingBottom: 20, paddingTop: 10}}>
        <RaisedButton label="Submit" onClick={this.handleOpen} style = {{marginLeft: 120}} />
        </div>

        <Dialog
          title="You missed:"
          actions={actions}
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
          autoScrollBodyContent={true}
        >

            {//using props that you get from Aa1Info.js to check if they are the correct answers
              }
            {this.props.alanine == "nonpolar" ? null : <div> Alanine </div> }
            {this.props.arginine == "basic" ? null : <div> Arginine </div>}
            {this.props.asparagine == "polar" ? null : <div> Asparagine </div>}
            {this.props.aspartate == "acidic" ? null : <div> Aspartic Acid </div>}
            {this.props.cystine == "polar" ? null : <div> Cysteine </div>}
            {this.props.glutamate == "acidic" ? null : <div> Glutamic Acid </div>}
            {this.props.glutamine == "polar" ? null : <div> Glutamine </div>}
            {this.props.glycine == "nonpolar" ? null : <div> Glycine </div>}
            {this.props.histidine == "basic" ? null : <div> Histidine </div>}
            {this.props.isoleucine == "nonpolar" ? null : <div> Isoleucine </div>}
            {this.props.leucine == "nonpolar" ? null : <div> Leucine </div>}
            {this.props.lysine == "basic" ? null : <div> Lysine </div>}
            {this.props.methionine == "nonpolar" ? null : <div> Methionine </div>}
            {this.props.phenylalanine == "nonpolar" ? null : <div> Phenylalanine </div>}
            {this.props.proline == "nonpolar" ? null : <div> Proline </div>}
            {this.props.serine == "polar" ? null : <div> Serine </div>}
            {this.props.threonine == "polar" ? null : <div> Threonine </div>}
            {this.props.tryptophan == "nonpolar" ? null : <div> Tryptophan </div>}
            {this.props.tyrosine == "polar" ? null : <div> Tyrosine </div>}
            {this.props.valine == "nonpolar" ? null : <div> Valine </div>}


            {//if the user gets all the questions right, then he will get a response saying none
              this.props.alanine == "nonpolar" && this.props.arginine == "basic" && this.props.asparagine == "polar"
            && this.props.aspartate == "acidic" && this.props.cystine == "polar" && this.props.glutamate == "acidic"
            && this.props.glutamine == "polar" && this.props.glycine == "nonpolar" && this.props.histidine == "basic"
            && this.props.isoleucine == "nonpolar" && this.props.leucine == "nonpolar"
            && this.props.lysine == "basic" && this.props.methionine == "nonpolar" && this.props.phenylalanine == "nonpolar"
            && this.props.proline == "nonpolar" && this.props.serine == "polar" && this.props.threonine == "polar"
            && this.props.tryptophan == "nonpolar" && this.props.tyrosine == "polar" && this.props.valine == "nonpolar"
            ? "none" : null}





        </Dialog>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/AaCategories/gradingCat.js